// extracted by mini-css-extract-plugin
module.exports = {"subtitle":"styles_subtitle__2PF4I","buttons":"styles_buttons__3yBG9"};